module.exports = __webpack_public_path__ + "img/result-icon-grey.12603cc4.png";